import script from "./CommunicationPreferencesForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunicationPreferencesForm.vue?vue&type=script&lang=ts&setup=true"

import "./CommunicationPreferencesForm.vue?vue&type=style&index=0&id=24cc8170&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24cc8170"]])

export default __exports__